export const athlete = 'ATHLETE';
export const team = 'TEAM';
export const league = 'LEAGUE';

export const getAccountGroupType = ({ leagueId, teamId, athleteId }) => {
    if (athleteId) return athlete;
    if (teamId && !athleteId) return team;
    if (leagueId && !teamId && !athleteId) return league;
};

export const TEAM_ACCOUNT_GROUP_ID = 1;
export const LEAGUE_ACCOUNT_GROUP_ID = 2;
export const ATHLETE_ACCOUNT_GROUP_ID = 3;
